(function () {
    const selectors = {
        section: ".js-benefits-slider",
        slider: ".js-benefits-slider-slider",
        prevButton: ".js-benefits-slider-prev",
        nextButton: ".js-benefits-slider-next"
    };

    let sections = [];

    function init() {
        sections = [...document.querySelectorAll(selectors.section)];

        sections.forEach(section => {
            if (section.dataset.initialized === 'true') return;

            const slider = section.querySelector(selectors.slider);
            const prevButton = section.querySelector(selectors.prevButton);
            const nextButton = section.querySelector(selectors.nextButton);

            if (!slider) return;

            initSlider(slider, prevButton, nextButton);
            section.dataset.initialized = 'true';
        });
    }

    function initSlider(slider, prevButton, nextButton) {
        return new Swiper(slider, {
            slidesPerView: "auto",
            spaceBetween: 16,
            threshold: 10,
            touchAngle: 30,
            breakpoints: {
                768: {
                    slidesPerView: "auto",
                    spaceBetween: 64,
                    centeredSlides: false
                }
            },
            navigation: {
                prevEl: prevButton,
                nextEl: nextButton
            }
        });
    }

    init();
})();
